export const DefaultParameters = {
    x: {
        init: (peak) => peak.x,
        min: (peak, peakShape) => peak.x - peakShape.fwhm * 2,
        max: (peak, peakShape) => peak.x + peakShape.fwhm * 2,
        gradientDifference: (peak, peakShape) => peakShape.fwhm * 2e-3,
    },
    y: {
        init: (peak) => peak.y,
        min: (peak) => (peak.y < 0 ? -1.1 : 0),
        max: (peak) => (peak.y < 0 ? 0 : 1.1),
        gradientDifference: () => 1e-3,
    },
    fwhm: {
        init: (peak, peakShape) => peakShape.fwhm,
        min: (peak, peakShape) => peakShape.fwhm * 0.25,
        max: (peak, peakShape) => peakShape.fwhm * 4,
        gradientDifference: (peak, peakShape) => peakShape.fwhm * 2e-3,
    },
    fwhmG: {
        init: (peak, peakShape) => peakShape.fwhm * 0.6,
        min: (peak, peakShape) => peakShape.fwhm * 0.6 * 0.25,
        max: (peak, peakShape) => peakShape.fwhm * 0.6 * 4,
        gradientDifference: (peak, peakShape) => peakShape.fwhm * 0.6 * 2e-3,
    },
    fwhmL: {
        init: (peak, peakShape) => peakShape.fwhm * 0.4,
        min: (peak, peakShape) => peakShape.fwhm * 0.4 * 0.25,
        max: (peak, peakShape) => peakShape.fwhm * 0.4 * 4,
        gradientDifference: (peak, peakShape) => peakShape.fwhm * 0.4 * 2e-3,
    },
    mu: {
        init: (peak, peakShape) => peakShape.mu,
        min: () => 0,
        max: () => 1,
        gradientDifference: () => 0.01,
    },
    gamma: {
        init: (peak, peakShape) => peakShape.gamma || 0.5,
        min: () => -1,
        max: () => 2,
        gradientDifference: () => 0.01,
    },
};
//# sourceMappingURL=DefaultParameters.js.map